var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"500px"}},[_c('iframe',{attrs:{"id":"iframe","frameborder":"0","height":"500","scrolling":"auto","src":"https://t.map.qq.com/43TjitZS","width":"100%"}})])
}]

export { render, staticRenderFns }